import { lt } from '@mews/framework';
import { useDialogForm } from '@mews-commander/form';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { DropdownItem, IconName } from '@optimus-web/core';
import { isBillVirtual } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { refetchBill } from '../../../ducks/bills';
import { PaymentRequestLinkDialogContent } from '../../../../payment/components/forms/PaymentRequestLink/PaymentRequestLinkDialogContent';
import { OrderItemDropdownButton } from '../ItemsGrouping/OrderItemListItemText/OrderItemIconMenu';
import { getAmountDueForBillIds } from '../../../selectors';

interface PaymentRequestItemMenu {
    paymentRequestId: string;
    accountId: string;
    billId: string;
}

export const PaymentRequestItemMenu = ({ paymentRequestId, accountId, billId }: PaymentRequestItemMenu) => {
    const dispatch = useCommanderThunkDispatch();
    const realBillId = useCommanderSelector((s) => isBillVirtual(s, { id: billId })) ? undefined : billId;

    const handleFormSuccess = (onSuccess?: () => void) => () => {
        onSuccess?.();
        dispatch(refetchBill({ accountId, billId: realBillId, extent: { payments: true } }));
    };

    const enterpriseId = useCurrentEnterpriseId();
    const { billAmounts } = useCommanderSelector((state) =>
        getAmountDueForBillIds(state, {
            enterpriseId,
            billIds: [billId],
        })
    );

    const [renderChangeReservationLinkDialog, toggleChangeReservationLinkDialog] = useDialogForm({
        title: lt('ChangeReservationLink'),
        renderForm: (props) => (
            <PaymentRequestLinkDialogContent
                {...props}
                paymentRequestId={paymentRequestId}
                accountId={accountId}
                onSuccess={handleFormSuccess(props.onSuccess)}
                billAmount={billAmounts[billId]}
            />
        ),
    });

    return (
        <>
            <OrderItemDropdownButton icon={IconName.More} variant="ghost" size="medium">
                <DropdownItem label={lt('ChangeReservationLink')} onClick={toggleChangeReservationLinkDialog} />
            </OrderItemDropdownButton>
            {renderChangeReservationLinkDialog()}
        </>
    );
};
